import { permissionGuard } from './permission.guard';

// --- User Guards ---
const USER_RESOURCE = 'User';
export const canReadUsersGuard = permissionGuard(USER_RESOURCE, 'read', 'You are not authorized to view users.');
export const canCreateUsersGuard = permissionGuard(USER_RESOURCE, 'create', 'You are not authorized to create users.');
export const canUpdateUsersGuard = permissionGuard(USER_RESOURCE, 'update', 'You are not authorized to edit users.');

// --- Role Guards ---
const ROLE_RESOURCE = 'Role';
export const canReadRolesGuard = permissionGuard(ROLE_RESOURCE, 'read', 'You are not authorized to view roles.');
export const canCreateRolesGuard = permissionGuard(ROLE_RESOURCE, 'create', 'You are not authorized to create roles.');
export const canUpdateRolesGuard = permissionGuard(ROLE_RESOURCE, 'update', 'You are not authorized to edit roles.');

// --- Branch Guards ---
const BRANCH_RESOURCE = 'Branch';
export const canReadBranchesGuard = permissionGuard(BRANCH_RESOURCE, 'read', 'You are not authorized to view branches.');
export const canCreateBranchesGuard = permissionGuard(BRANCH_RESOURCE, 'create', 'You are not authorized to create branches.');
export const canUpdateBranchesGuard = permissionGuard(BRANCH_RESOURCE, 'update', 'You are not authorized to edit branches.');

// --- Business Unit Guards ---
const BUSINESS_UNIT_RESOURCE = 'Business Unit';
export const canReadBusinessUnitsGuard = permissionGuard(BUSINESS_UNIT_RESOURCE, 'read', 'You are not authorized to view business units.');
export const canCreateBusinessUnitsGuard = permissionGuard(BUSINESS_UNIT_RESOURCE, 'create', 'You are not authorized to create business units.');
export const canUpdateBusinessUnitsGuard = permissionGuard(BUSINESS_UNIT_RESOURCE, 'update', 'You are not authorized to edit business units.');

// --- Business Guards ---
const BUSINESS_RESOURCE = 'Business';
export const canReadBusinessesGuard = permissionGuard(BUSINESS_RESOURCE, 'read', 'You are not authorized to view businesses.');
export const canCreateBusinessesGuard = permissionGuard(BUSINESS_RESOURCE, 'create', 'You are not authorized to create businesses.');
export const canUpdateBusinessesGuard = permissionGuard(BUSINESS_RESOURCE, 'update', 'You are not authorized to edit businesses.');

// --- Customer Guards ---
const CUSTOMER_RESOURCE = 'Customer';
export const canReadCustomersGuard = permissionGuard(CUSTOMER_RESOURCE, 'read', 'You are not authorized to view customers.');
export const canCreateCustomersGuard = permissionGuard(CUSTOMER_RESOURCE, 'create', 'You are not authorized to create customers.');
export const canUpdateCustomersGuard = permissionGuard(CUSTOMER_RESOURCE, 'update', 'You are not authorized to edit customers.');
// --- Loaction Guards ---
const LOCATION_RESOURCE = 'Location';
export const canReadLoactionsGuard = permissionGuard(LOCATION_RESOURCE, 'read', 'You are not authorized to view loactions.');
export const canCreateLoactionsGuard = permissionGuard(LOCATION_RESOURCE, 'create', 'You are not authorized to create loactions.');
export const canUpdateLoactionsGuard = permissionGuard(LOCATION_RESOURCE, 'update', 'You are not authorized to edit loactions.');

// --- Brand Guards ---
const BRAND_RESOURCE = 'Brand';
export const canReadBrandsGuard = permissionGuard(BRAND_RESOURCE, 'read', 'You are not authorized to view brands.');
export const canCreateBrandsGuard = permissionGuard(BRAND_RESOURCE, 'create', 'You are not authorized to create brands.');
export const canUpdateBrandsGuard = permissionGuard(BRAND_RESOURCE, 'update', 'You are not authorized to edit brands.');

// --- Sub-Brand Guards ---
const SUB_BRAND_RESOURCE = 'Sub Brand';
export const canReadSubBrandsGuard = permissionGuard(SUB_BRAND_RESOURCE, 'read', 'You are not authorized to view sub-brands.');
export const canCreateSubBrandsGuard = permissionGuard(SUB_BRAND_RESOURCE, 'create', 'You are not authorized to create sub-brands.');
export const canUpdateSubBrandsGuard = permissionGuard(SUB_BRAND_RESOURCE, 'update', 'You are not authorized to edit sub-brands.');

// --- Supplier Guards ---
const SUPPLIER_RESOURCE = 'Supplier';
export const canReadSuppliersGuard = permissionGuard(SUPPLIER_RESOURCE, 'read', 'You are not authorized to view suppliers.');
export const canCreateSuppliersGuard = permissionGuard(SUPPLIER_RESOURCE, 'create', 'You are not authorized to create suppliers.');
export const canUpdateSuppliersGuard = permissionGuard(SUPPLIER_RESOURCE, 'update', 'You are not authorized to edit suppliers.');

// --- Supplier Site Guards ---
const SUPPLIER_SITE_RESOURCE = 'Supplier Site';
export const canReadSupplierSitesGuard = permissionGuard(SUPPLIER_SITE_RESOURCE, 'read', 'You are not authorized to view supplier sites.');
export const canCreateSupplierSitesGuard = permissionGuard(SUPPLIER_SITE_RESOURCE, 'create', 'You are not authorized to create supplier sites.');
export const canUpdateSupplierSitesGuard = permissionGuard(SUPPLIER_SITE_RESOURCE, 'update', 'You are not authorized to edit supplier sites.');

// --- Items Guards ---
const ITEM_RESOURCE = 'Item';
export const canReadItemsGuard = permissionGuard(ITEM_RESOURCE, 'read', 'You are not authorized to view items.');
export const canCreateItemsGuard = permissionGuard(ITEM_RESOURCE, 'create', 'You are not authorized to create items.');
export const canUpdateItemsGuard = permissionGuard(ITEM_RESOURCE, 'update', 'You are not authorized to edit items.');

// --- Activity Type Guards ---
const ACTIVITY_TYPE_RESOURCE = 'Activity Type';
export const canReadActivityTypesGuard = permissionGuard(ACTIVITY_TYPE_RESOURCE, 'read', 'You are not authorized to view activity types.');
export const canCreateActivityTypesGuard = permissionGuard(ACTIVITY_TYPE_RESOURCE, 'create', 'You are not authorized to create activity types.');
export const canUpdateActivityTypesGuard = permissionGuard(ACTIVITY_TYPE_RESOURCE, 'update', 'You are not authorized to edit activity types.');

//  Rebate permissions 
// --- Fixed Rebate Guards ---
const FIXED_REBATE_RESOURCE = 'Fixed Rebate';
export const canCreateFixedRebatesGuard = permissionGuard(FIXED_REBATE_RESOURCE, 'create', 'You are not authorized to create fixed rebates.');

// --- Progressive Rebate Guards ---
const PROGRESSIVE_REBATE_RESOURCE = 'Progressive Rebate';
export const canCreateProgressiveRebatesGuard = permissionGuard(PROGRESSIVE_REBATE_RESOURCE, 'create', 'You are not authorized to create progressive rebates.');
// --- Progressive Rebate Guards ---
const FIXED_BY_SITE_REBATE_RESOURCE = 'Fixed By Site Rebate';
export const canCreateFixedBySiteRebatesGuard = permissionGuard(FIXED_BY_SITE_REBATE_RESOURCE, 'create', 'You are not authorized to create fixed by site rebates.');

// --- KBD Guards ---
const KBD_RESOURCE = 'KBD';
export const canReadKBDsGuard = permissionGuard(KBD_RESOURCE, 'read', 'You are not authorized to view rebates.');
export const canUpdateKBDsGuard = permissionGuard(KBD_RESOURCE, 'update', 'You are not authorized to edit rebates.');

// --- Rebate Results Guards ---
const REBATE_RESULT_RESOURCE = 'Rebate Results';
export const canReadRebateResultsGuard = permissionGuard(REBATE_RESULT_RESOURCE, 'read', 'You are not authorized to view rebate results.');
export const canGenerateRebateResultsGuard = permissionGuard(REBATE_RESULT_RESOURCE, 'update', 'You are not authorized to generate rebate results.');

const CLAIM_RESULT_RESOURCE = 'Claim Results';
export const canReadClaimResultsGuard = permissionGuard(CLAIM_RESULT_RESOURCE, 'read', 'You are not authorized to view claim results.');
export const canGenerateClaimResultsGuard = permissionGuard(CLAIM_RESULT_RESOURCE, 'update', 'You are not authorized to generate claim results.');

// --- Claim Contract Guards ---
const CLAIM_CONTRACT_RESOURCE = 'Claim Contract';
export const canReadClaimContractsGuard = permissionGuard(CLAIM_CONTRACT_RESOURCE, 'read', 'You are not authorized to view claim contracts.');
export const canCreateClaimContractsGuard = permissionGuard(CLAIM_CONTRACT_RESOURCE, 'create', 'You are not authorized to create claim contracts.');
export const canUpdateClaimContractsGuard = permissionGuard(CLAIM_CONTRACT_RESOURCE, 'update', 'You are not authorized to edit claim contracts.');
export const canDeleteClaimContractsGuard = permissionGuard(CLAIM_CONTRACT_RESOURCE, 'delete', 'You are not authorized to delete claim contracts.');

// --- Workflow Configuration Guards ---
const WORKFLOW_CONFIG_RESOURCE = 'Approval Workflow';
export const canManageWorkflowConfigGuard = permissionGuard(WORKFLOW_CONFIG_RESOURCE, ['create', 'update'], 'You are not authorized to manage workflow configurations.');
